const itemsAdapter = (data) => {
  return {
    title: data.title,
    text: data.text,
  };
};

export default ({ data }) => {
  return {
    items: data?.items.map(itemsAdapter),
  };
};
